import {
  Card,
  Group,
  Indicator,
  ThemeIcon,
  UnstyledButton,
  Burger,
} from "@mantine/core";
import { IconBell } from "@tabler/icons-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";

import { LAYOUT_APP_BAR_HEIGHT, LayoutAppBarProps } from ".";
import { GetUserNotificationsCountDocument } from "../../../generated/graphql";
import { OrderSearch } from "./OrderSearch";

export const LayoutAppBarV2 = ({
  navbarOpened,
  toggleNavbar,
}: LayoutAppBarProps) => {
  const navigate = useNavigate();
  const [isNotificationsHovered, setIsNotificationsHovered] = useState(false);

  const { data: getUserNotificationsCount } = useQuery(
    GetUserNotificationsCountDocument,
    {
      fetchPolicy: "network-only",
    }
  );

  return (
    <Card
      w="100%"
      h={LAYOUT_APP_BAR_HEIGHT}
      bg="cardBackground"
      radius={0}
      shadow="none"
      py={0}
    >
      <Group
        w="100%"
        h="100%"
        justify="space-between"
        align="center"
        wrap="nowrap"
      >
        <Burger
          opened={navbarOpened}
          onClick={toggleNavbar}
          hiddenFrom="xs"
          size="sm"
          mr="auto"
          aria-label={navbarOpened ? "Fermer le menu" : "Ouvrir le menu"}
        />
        <OrderSearch />
        <UnstyledButton
          aria-label="Notifications"
          onMouseEnter={() => setIsNotificationsHovered(true)}
          onMouseLeave={() => setIsNotificationsHovered(false)}
          onClick={() => navigate("/notifications")}
        >
          <Indicator
            size={5}
            offset={8}
            color="amber"
            disabled={
              (getUserNotificationsCount?.getUserNotificationsCount ?? 0) < 1
            }
          >
            <ThemeIcon
              size="md"
              variant={isNotificationsHovered ? "light" : "white"}
              color="brand"
            >
              <IconBell size={18} />
            </ThemeIcon>
          </Indicator>
        </UnstyledButton>
      </Group>
    </Card>
  );
};
